import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

export const actionsWrapperStyle = (theme: Theme) => css({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.backgroundColors.secondary,
  boxSizing: 'border-box',
  padding: '5px 10px 5px 16px',
});

export const toolbarButtonWrapperStyle = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  minHeight: 34,
});

export const boundaryOptionsHeaderStyle = (theme: Theme) => css({
  backgroundColor: theme.backgroundColors.secondary,
  borderTop: `1px solid ${theme.lineColors.basePrimary}`,
  boxSizing: 'border-box',
  padding: '8px 16px',
  width: '100%',
});

export const boundaryOptionStyle = css({
  display: 'flex',
  alignItems: 'center',
  padding: '4px 0',
  width: '100%',
});

export const primaryBoundaryLabelStyle = css({
  textTransform: 'uppercase',
  fontSize: '14px',
});

export const checkboxStyle = (theme: Theme) => css({
  textTransform: 'uppercase',
  color: theme.textColors.secondary,
  fontSize: '12px',
});

export const toolbarButtonStyle = css({
  marginLeft: 6,
});
